import axiosMultisite from 'shared/tools/axiosMultisite';
import axios from 'axios';

let abortController = null;

export const getAutoSuggest = async function getAutoSuggest(url) {
	if (abortController) {
		abortController.abort();
	}
	abortController = new AbortController();

	try {
		const res = await axiosMultisite.get(url, {
			signal: abortController.signal
		});
		abortController = null;
		return res;
	} catch (err) {
		if (!axios.isCancel(err)) {
			console.error(err);
			abortController = null;
		}
	}
}

const AutoSuggestService = {
	getAutoSuggest,
};

export default AutoSuggestService;
